import i18n from 'scoreboard/components/i18n'

function getEditorTitle(widget) {
	let { id, type } = widget
	let typeKey = 'forms.widgets.widget.' + type
	let keySuffix = id ? 'edit' : 'create'
	return i18n.get(`forms.widgets.${keySuffix}`, typeKey)
}

export default getEditorTitle

getEditorTitle.__filename__ = 'forms/widgets/get-editor-title.js'
